import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import AdminLayout from "../components/AdminLayout";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../styles/admin_home.css";

import { getRoleNames, getVisibleAdminSections } from "../types/adminSections";

const AdminHomePage: React.FC = () => {
    const { roles } = useAuth();

    const roleNames = getRoleNames(roles);
    const visibleSections = getVisibleAdminSections(roleNames).filter(
        (s) => s.path !== "/admin" // чтобы не показывать ссылку "Админ-панель" на самой админке
    );

    return (
        <AdminLayout>
            <HelmetProvider>
                <Helmet title="Админ-панель" />
            </HelmetProvider>

            <div className="page_content admin-home">
                <section className="admin-card admin-home-card">
                    <h1 className="admin-heading">Админ-панель</h1>
                    <p className="admin-subtitle">Добро пожаловать!</p>

                    <div className="admin-home-sections">
                        {visibleSections.map((sec) => (
                            <Link key={sec.path} to={sec.path} className="admin-home-link">
                                {sec.label}
                            </Link>
                        ))}

                        {visibleSections.length === 0 && (
                            <div className="admin-home-no-access">
                                У вас нет доступа ни к одному разделу панели.
                            </div>
                        )}
                    </div>
                </section>
            </div>
        </AdminLayout>
    );
};

export default AdminHomePage;
